import { __assign, __extends } from "tslib";
import { ValueObject } from '../../../../../base/ddd-types/value-object';
import { ACCOUNT_TYPE } from '@tencent/ark-utils/lib/base/types';
import { NOT_LOGIN_TINYID } from '../user-info.interface';
var BaseUserInfoObjectValue = /** @class */ (function (_super) {
    __extends(BaseUserInfoObjectValue, _super);
    function BaseUserInfoObjectValue(baseUserInfo) {
        var _this = _super.call(this) || this;
        _this.wedocOpenId = '';
        _this.wedriveUin = '';
        _this.corpId = '';
        _this.corpName = '';
        _this.englishName = '';
        _this.loginType = ACCOUNT_TYPE.UNKNOWN;
        _this.nowUserIndex = '';
        _this.openId = '';
        _this.tinyId = NOT_LOGIN_TINYID;
        _this.uidSource = ACCOUNT_TYPE.UNKNOWN;
        _this.uin = '';
        _this.userId = '';
        _this.userName = '';
        _this.userPic = '';
        _this.settings = {
            language: '',
            toolbarMode: '',
            vipTheme: '',
            openWithDesktop: '',
        };
        if (!baseUserInfo) {
            return _this;
        }
        if (baseUserInfo.tinyId) {
            _this.jsonObj2Class(baseUserInfo);
            return _this;
        }
        _this.jsonObj2Class(__assign(__assign({}, baseUserInfo), { tinyId: NOT_LOGIN_TINYID }));
        return _this;
    }
    return BaseUserInfoObjectValue;
}(ValueObject));
export { BaseUserInfoObjectValue };
